






















































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { State } from 'vuex-class'

import { projectVariables } from '../../../../../../../../../../service-for-environment-variables/environment-variables-type-1-general-variables/general-variables-type-1-project-variables/project-variables-1-introduction'

import JobEmploymentResourceItem3FindEmployeesToHire from './service-for-job-employment-resource-item/job-employment-resource-item-3-find-employees-to-hire.vue'


@Component({
  components: {
    JobEmploymentResourceItem3FindEmployeesToHire
  }
})
class YourAccountHelperComponents6JobEmploymentResourceItem extends Vue {
  @State('isMobileDevice') isMobileDevice?: boolean

  @Prop({ default: '' }) accountId?: string
  @Prop({ default: false }) isPublicAccountViewing?: boolean

  projectName: string = projectVariables.projectName

  // a list of the indexes of the panels that are open by default
  // [0, 2, 3, 1] means all 4 panels are expanded
  isExandedPanelList: number[] = []

  isOpenAccountDescription: number = 0
  isOpenAccountStatistics: number = 0
  isOpenTransactionStatistics: number = 0
}

export default YourAccountHelperComponents6JobEmploymentResourceItem

